import { render, staticRenderFns } from "./AboutPriorityParentingMatterOrder.vue?vue&type=template&id=2d43059f&scoped=true"
import script from "./AboutPriorityParentingMatterOrder.vue?vue&type=script&lang=ts"
export * from "./AboutPriorityParentingMatterOrder.vue?vue&type=script&lang=ts"
import style0 from "./AboutPriorityParentingMatterOrder.vue?vue&type=style&index=0&id=2d43059f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d43059f",
  null
  
)

export default component.exports